// DEPRECATED: Google Drive proxy is no longer used - images are now hosted in Firebase Storage
// Keeping this function for backward compatibility but it should be removed after migration
export const extractDriveFileId = (url) => {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';

  const driveMatch = trimmed.match(/\/file\/d\/([^/]+)\//);
  if (driveMatch?.[1]) return driveMatch[1];

  const idParamMatch = trimmed.match(/[?&]id=([^&]+)/);
  if (idParamMatch?.[1]) return idParamMatch[1];

  return '';
};

// UPDATED: imageUrl field contains public folder paths directly
// No conversion needed - use the URL as-is from the database
export const getImageSrc = (url, FN_BASE) => {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';

  // DEPRECATED: Legacy Google Drive proxy fallback - kept for backward compatibility only
  const fileId = extractDriveFileId(trimmed);
  if (fileId && FN_BASE) {
    console.warn('DEPRECATED: Using legacy Google Drive proxy. All images should now use public folder URLs.');
    return `${FN_BASE}/serveDriveImage?fileId=${encodeURIComponent(fileId)}`;
  }

  // Return public folder URL as-is (format: /products/{filename}.webp)
  return trimmed;
};
